import {Component, OnInit, ViewChild} from '@angular/core';

import {AlertService, AuthenticationService, ClientProfileService, ProjectService} from '../../_services/index';

import {ActivatedRoute, Router} from '@angular/router';

import {PoamItem, Project, User} from '../../_models/index';
import {LoginHelper} from '../../helpers';
import { IndexConfigService } from "../../_services/index.config.service";
import { AppTextResourcesService } from '../../_services/app.text.resources.service';

@Component({
    standalone: false,
  selector: "poam-component",
  templateUrl: 'poam.component.html',
  styleUrls: ['./poam.component.scss'],
})

export class PoamComponent implements OnInit {
  poamItems: PoamItem[] = [];
  currentUser: User;
  projectId: number;
  currentYear: number;
  rowGroupMetadata: any = {};
  tenantName: string;
  token = LoginHelper.getFileToken();
  cols: any[] = [
    {'field': 'currentYearSequence', 'header': 'ID'},
    {'field': 'name', 'header': 'Name'},
    {'field': 'topic', 'header': 'Topic'},
    {'field': 'loe', 'header': 'LOE'},
    {'field': 'requirementOrGuidance', 'header': 'Reqm\'t or Guidance'},
    {'field': 'affectedSystems', 'header': 'Affected Systems'},
    {'field': 'complianceAreaControlId', 'header': 'Control Ref'},
    {'field': 'identificationDate', 'header': 'Identification Date'},
    {'field': 'weaknessDescription', 'header': 'Description'},
    {'field': 'riskLevel', 'header': 'Risk'},
    {'field': 'remediationPlansActionsMilestones', 'header': 'Planned Remediation'},
    {'field': 'changesToRemediationPlansActionsMilestones', 'header': 'Changes to Remediation Plan', display: false},
    {'field': 'responsibleParty', 'header': 'Responsible Party'},
    {'field': 'scheduledCompletionDate', 'header': 'Original Target Date'},
    {'field': 'revisedTargetDate', 'header': 'Revised Target Date', display: false},
    {'field': 'howIdentified', 'header': 'How Identified?'},
    {'field': 'currentStatus', 'header': 'Current Status'},
    {'field': 'actualCompletionDate', 'header': 'Actual Completion Date', display: false},
    {'field': 'assessmentNotes', 'header': 'Related Assessment', display: false},
    {'field': 'comments', 'header': 'Comments', display: false},
  ];
  lowMediumHigh = {0: 'Low', 1: 'Medium', 2: 'High'};
  @ViewChild('poamTable') table: Element;
  public project: Project;

  constructor(
    public projectService: ProjectService,
    public router: Router,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public config: IndexConfigService,
    public authenticationService: AuthenticationService,
    public clientProfileService: ClientProfileService,
    private constants: AppTextResourcesService) {

    this.projectId = route.snapshot.params['projectId'];
    this.currentYear = new Date(Date.now()).getFullYear();
  }

  ngOnInit() {

    const tenantName = this.tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.projectService.getById(this.projectId).subscribe(p => this.project = p);

    this.clientProfileService.getUserSetting('PoamTable').subscribe(c => {
      if (c) {
        for (let i = 0; i < c.columnWidths.length; i++) {
          this.cols[i].width = c.columnWidths[i];
        }
      }
    })

    this.loadProjectControlItems();
  }

  public loadProjectControlItems() {

    const year = new Date(Date.now()).getFullYear();

    this.projectService.getForPoam(this.projectId)
      .subscribe(project => {
          const projectControlItems = project.projectControlItems.filter(x => x.actionPlans != null && x.actionPlans.length > 0);

          const index = 1;
          const poams = [];
          projectControlItems.forEach(projectControlItem => {
            projectControlItem.actionPlans.filter(i => i.type == 0).sort((a, b) => a.actionPlanId > b.actionPlanId ? 1 : -1).forEach(actionItem => {
              const existing = poams.find(a => actionItem.actionPlanTemplateId && a.actionPlanTemplateId == actionItem.actionPlanTemplateId);
              if (!actionItem.actionPlanTemplateId || !existing) {
                poams.push(new PoamItem(
                  actionItem.pOAMId || this.getIndex(year, poams),
                  projectControlItem.controlItem.complianceAreaControlId,
                  actionItem.name,
                  actionItem.topic,
                  this.lowMediumHigh[actionItem.loe],
                  actionItem.requirementOrGuidance,
                  actionItem.affectedSystems,
                  actionItem.weaknessDescription,
                  actionItem.riskLevel,
                  actionItem.identificationDate,
                  actionItem.scheduledCompletionDate,
                  actionItem.actualCompletionDate,
                  actionItem.remediationPlansActionsMilestones,
                  actionItem.changesToRemediationPlansActionsMilestones,
                  actionItem.comments,
                  projectControlItem.projectControlItemId,
                  actionItem.responsibleParty,
                  projectControlItem.revisedTargetDate,
                  actionItem.howIdentified,
                  {
                    0: "Not Started",
                    1: "In-Progress",
                    2: "Resolved",
                    3: "Awaiting Review",
                    4: "Reviewed - Not POAM"
                  }[actionItem.currentStatus],
                  projectControlItem.assessmentNotes.filter(n => (',' + actionItem.assessmentNoteIds + ',').indexOf(',' + n.assessmentNoteId + ',') >= 0),
                  actionItem.actionPlanId,
                  actionItem.impactedControls,
                  actionItem.actionPlanTemplateId));
              } else if (existing) {
                  existing.complianceAreaControlId += "\r\n" + projectControlItem.controlItem.complianceAreaControlId;
              }
            })
          });

          this.poamItems = poams;

          this.updateRowGroupMetaData();
        },

        error => {
          const errorMessage = 'An error occurred while loading projects.';
          this.alertService.error(errorMessage);
        });
  }

  public updatePOAMId(row) {
    this.projectService.updatePOAMId(row.actionPlanId, row.currentYearSequence).subscribe(() => {
      this.loadProjectControlItems();
    })
  }

  getIndex(year, poams) {
    let index = 1;
    while (poams.find(p => p.currentYearSequence == (year + ' - ' + index))) index++;
    return year + ' - ' + index;
  }

  updateRowGroupMetaData() {
    if (this.poamItems) {
      for (let i = 0; i < this.poamItems.length; i++) {
        let rowData = this.poamItems[i];
        let brand = rowData.complianceAreaControlId;
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = this.poamItems[i - 1];
          let previousRowGroup = previousRowData.complianceAreaControlId;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }
  }

  onColumnResize(event) {
    setTimeout(() => {
      const row = (<any>this.table).tableViewChild.nativeElement.children[0].children[0];
      const width = row.clientWidth;
      const sizes = [];
      for (let i = 0; i < row.children.length - 2; i++) {
        sizes.push(row.children[i].clientWidth / width * 100 + '%');
      }
      this.clientProfileService.saveUserSetting("PoamTable", {columnWidths: sizes}).subscribe(() => {
      });
    }, 500);
  }

  protected readonly encodeURIComponent = encodeURIComponent;
}
